// Define the index of the menu items
const MENU_ITEM = {
    HOME: 0,
    SERVICES: 1,
    PRICING: 2,
    CONTACT: 3,
    NONE: 10
}

export { MENU_ITEM }